<template>
  <div>
       <Breadcrumb :headers="headers"></Breadcrumb>
    <List
      url="getPartnerList"
      deleteUrl="deletePartner"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealGrade"
      :data="searchData" 
      :isAdd="false"
      @edit="edit"
      :operat="operat">
      <div slot="Filter"> 
        <el-input v-model="searchData.Key" placeholder="Company Name/Sales Representative" style="width:400px;"></el-input>
        <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
        <el-button @click="sendEmail"    type="primary" style="margin-left:10px;">Send Email</el-button>
      </div>
    </List>
    <UpdateBox
      :updateType="updateType"
      :initForm="updateForm"
      v-if="updateBlock"
      @close="updateBlock = false"
    ></UpdateBox>
     <SendEmail v-if="sendEmailBlock" @close="sendEmailBlock = false" ></SendEmail>
  </div>
</template>


<script>
import List from "../components/common/List.vue";
import { PARTNERGRADE} from "@/components/Partner/data.js";
import Breadcrumb from "../components/common/Breadcrumb.vue";
import UpdateBox from "../components/Partners/UpdateBox.vue";
import SendEmail from "../components/Partners/SendEmail.vue";
export default {
    components: {
        List,
        UpdateBox,
        Breadcrumb,
        SendEmail
    },
    data() {
        return {
            tanle: [
                { name: "CompanyName", label: "Company Name" },
                { name: "FullName", label: "Full Name" },
                { name: "Email", label: "Email" },
                { name: "GradeName", label: "Grade" },
                { name: "accountFullName", label: "Sales Representative", type:1,width:'300px'  }
            ],
            searchData: { Key: "" },
            headers:[{label:"Home",path:"/dashboard"},{label:"Partners",path:"/partners"}],
            updateList: 0,
            updateForm: {},
            updateBlock: false,
            sendEmailBlock: false,
            operat: [{
                text:"Info",
                eventName:"edit",
                type:'primary',
                method (data) {
                    return (data.Status !== "1");
                } 
            }]
        };
    },
    methods: {
        dealGrade (data) {
            for(let i in data) {
                data[i].GradeName = PARTNERGRADE[data[i].Grade];
                data[i].FullName = data[i].FirstName + " " + data[i].LastName;
            }
            return data;
        },
        edit (val) {
            val.Account = val.AccountID;
            val.Partner = val.PartnerID;
            this.updateForm = val;
            this.updateType = "edit";
            this.updateBlock = true;
        },
        sendEmail () {
            this.$router.push("/partnersSendEmail");
        }
    }
};
</script>
